module.exports = __webpack_public_path__ + "img/sample-report-05@3x.0c0a6ed1.png";